import React from 'react';
import { tinaField } from 'tinacms/dist/react';
import type { TinaMarkdown } from 'tinacms/dist/rich-text';
import type { Block } from '@/cms/types';
import type { ExtractProps } from '@/utils/props';
import { MarkdownText } from '@/app/(base)/components/markdown';

export function Content(
  data: Block & {
    body?: ExtractProps<typeof TinaMarkdown>['content'];
    textAlign?: string;
    paragraphIndent?: boolean;
  },
): React.JSX.Element {
  const { body, textAlign, paragraphIndent } = data;

  const contentStyle =
    'prose prose-invert prose-a:text-gray-400 prose-lg lg:prose-xl';

  let textStyle = 'text-gray-400 font-normal';
  if (textAlign === 'centered') {
    textStyle += ' text-center';
  } else if (textAlign === 'full-width') {
    textStyle += ' text-justify';
  }
  if (paragraphIndent) {
    textStyle += ' prose-p:indent-8';
  }

  return (
    <section>
      <div
        className={`container py-7 px-4 md:px-0 ${textStyle} ${contentStyle}`}
        data-tina-field={tinaField(data, 'body')}>
        {body ? <MarkdownText content={body} /> : null}
      </div>
    </section>
  );
}
